module.exports = __webpack_public_path__ + "static/img/douyin_code.78c42b38.png";